<template>
  <div class="checkout-payment-succeeded">
    <div class="checkout-payment-succeeded__container">
      <img
        id="checkout-header-logotipo-playkids"
        class="checkout-payment-succeeded__container__logo"
        src="@/assets/playkids-logo-black.png"
        alt
      />
      <div class="checkout-payment-succeeded__container__options-container">
        <img
          class="checkout-payment-succeeded__container__options-container__smarttv"
          src="@/assets/checkout/smart-tv.png"
          alt
        />
        <img
          class="checkout-payment-succeeded__container__options-container__smarttv-content"
          src="@/assets/checkout/smart-tv-content.png"
          alt
        />
        <img
          class="checkout-payment-succeeded__container__options-container__iphonex"
          src="@/assets/checkout/apple-iphone-x.png"
          alt
        />
        <img
          class="checkout-payment-succeeded__container__options-container__imac"
          src="@/assets/checkout/apple-imac-retina.png"
          alt
        />
      </div>
      <div class="checkout-payment-succeeded__container__text-container">
        <h1 id="checkout-success-titulo" class="checkout-payment-succeeded__container__text-container__title"
          v-html="$t('checkout.checkoutPaymentSucceeded.title', { kidNameList: preparedKidList })"
        >
        </h1>
        <h3 class="checkout-payment-succeeded__container__text-container__subtitle"
          v-html="$t('checkout.checkoutPaymentSucceeded.subtitle')"
        >
        </h3>
        <p class="checkout-payment-succeeded__container__text-container__description"
          v-html="$t('checkout.checkoutPaymentSucceeded.description')"
        >
        </p>
        <btn color="purple"
          class="checkout-payment-succeeded__container__text-container__button"
          @click="finish"
        >
          {{ $t('checkout.checkoutPaymentSucceeded.finish') }}
        </btn>
      </div>
      <ul class="checkout-payment-succeeded__container__version-container">
        <li class="checkout-payment-succeeded__container__version-container__item">
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6651 14.811C16.3781 15.475 16.0381 16.086 15.6441 16.648C15.1071 17.415 14.6661 17.945 14.3281 18.24C13.8031 18.722 13.2391 18.97 12.6361 18.984C12.2041 18.984 11.6821 18.861 11.0741 18.611C10.4641 18.362 9.90414 18.24 9.39114 18.24C8.85414 18.24 8.27814 18.362 7.66114 18.611C7.04514 18.861 6.54714 18.992 6.16614 19.004C5.58914 19.029 5.01214 18.775 4.43714 18.24C4.07014 17.92 3.61114 17.37 3.06014 16.592C2.47014 15.763 1.98514 14.798 1.60514 13.701C1.19814 12.514 0.994141 11.366 0.994141 10.254C0.994141 8.98102 1.26914 7.88202 1.82014 6.96202C2.25414 6.22202 2.83014 5.63902 3.55014 5.21102C4.27114 4.78202 5.05114 4.56302 5.89014 4.54902C6.35014 4.54902 6.95314 4.69102 7.70014 4.97102C8.44714 5.25102 8.92714 5.39302 9.13614 5.39302C9.29414 5.39302 9.82514 5.22602 10.7291 4.89502C11.5821 4.58802 12.3021 4.46102 12.8921 4.51102C14.4921 4.64002 15.6931 5.27002 16.4921 6.40602C15.0621 7.27302 14.3551 8.48602 14.3691 10.043C14.3811 11.256 14.8221 12.265 15.6861 13.066C16.0781 13.438 16.5151 13.725 17.0011 13.929C16.8951 14.236 16.7831 14.529 16.6651 14.811ZM12.9981 0.380024C12.9981 1.33002 12.6501 2.21802 11.9591 3.03902C11.1231 4.01502 10.1131 4.58002 9.01814 4.49102C9.00414 4.37702 8.99714 4.25702 8.99714 4.13102C8.99714 3.21802 9.39314 2.24202 10.1001 1.44302C10.4521 1.03902 10.9001 0.702024 11.4431 0.434023C11.9851 0.170024 12.4971 0.0240234 12.9791 -0.000976562C12.9921 0.127023 12.9981 0.254024 12.9981 0.380024Z" fill="#A217AB"/>
          </svg>
          Apple Store
        </li>
        <li class="checkout-payment-succeeded__container__version-container__item">
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.954 8.61595L11.911 5.65895L2.36 0.290951C1.727 -0.0510492 1.134 -0.099049 0.614 0.274951L8.954 8.61595ZM12.415 12.078L15.489 10.349C16.089 10.013 16.418 9.53695 16.418 9.00895C16.418 8.48195 16.089 8.00495 15.49 7.66895L12.707 6.10595L9.574 9.23795L12.415 12.078ZM0.0999999 1.00195C0.0359999 1.19895 0 1.41895 0 1.65995V16.365C0 16.746 0.0840001 17.0739 0.236 17.3349L8.333 9.23695L0.0999999 1.00195ZM8.954 9.85695L0.902 17.91C1.056 17.969 1.222 18 1.397 18C1.709 18 2.034 17.908 2.365 17.724L11.62 12.527L8.954 9.85695Z" fill="#A217AB"/>
          </svg>
          Play Store
        </li>
        <li class="checkout-payment-succeeded__container__version-container__item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.64652 3.85355L10.793 6H3.81818C2.81403 6 2 6.89543 2 8V19C2 20.1046 2.81403 21 3.81818 21H4V21.7929H6V21H18V21.7929H20V21H20.1818C21.186 21 22 20.1046 22 19V8C22 6.89543 21.186 6 20.1818 6H12.793L14.6465 4.14644C14.8418 3.95118 14.8418 3.6346 14.6465 3.43934C14.4513 3.24408 14.1347 3.24408 13.9394 3.43934L11.7613 5.61745C11.737 5.55249 11.6988 5.49158 11.6465 5.43934L9.35363 3.14645C9.15837 2.95118 8.84178 2.95118 8.64652 3.14645C8.45126 3.34171 8.45126 3.65829 8.64652 3.85355ZM3.81818 8H18V19H3.81818L3.81818 8ZM20 11.7929C20.5523 11.7929 21 11.3452 21 10.7929C21 10.2406 20.5523 9.79289 20 9.79289C19.4477 9.79289 19 10.2406 19 10.7929C19 11.3452 19.4477 11.7929 20 11.7929ZM21 14.7929C21 15.3452 20.5523 15.7929 20 15.7929C19.4477 15.7929 19 15.3452 19 14.7929C19 14.2406 19.4477 13.7929 20 13.7929C20.5523 13.7929 21 14.2406 21 14.7929Z" fill="#A217AB"/>
          </svg>
          Smart TV
        </li>
        <li class="checkout-payment-succeeded__container__version-container__item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 5H5C3.89543 5 3 5.89543 3 7V16H1V17C1 18.1046 1.89543 19 3 19H21C22.1046 19 23 18.1046 23 17V16H21V7C21 5.89543 20.1046 5 19 5ZM19 16H5V7H19V16Z" fill="#A217AB"/>
          </svg>
          PK Web
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from 'store'

export default {
  name: 'checkout-payment-succeeded',
  props: {
    kidList: Array
  },
  computed: {
    preparedKidList() {
      if (this.kidList && this.kidList.length) {
        return this.kidList.map(i => i.name).join(', ')
      }
      return ''
    }
  },
  methods: {
    finish() {
      store.set('onboarding_finished', false)
      this.$router.push({ name: 'browse' })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-payment-succeeded {
  position: relative;
  display: flex;
  justify-content: center;

  background-image: url('~@/assets/checkout/result-succeeded-section-1.png'), url('~@/assets/checkout/result-succeeded-section-2.png');
  background-repeat: no-repeat;
  background-size: 1440px 289px, 1440px 645px;
  background-position: -38rem 0, -38rem 0;

  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 350px;
    margin-top: 12rem;

    &__logo {
      width: 250px;
      height: 153px;
      margin-bottom: 6rem;
    }
    &__options-container {
      position: relative;
      width: 350px;
      height: 216px;

      &__iphonex {
        position: absolute;
        bottom: 50px;
        left: 0;
        width: 76px;
        height: 39px;
      }
      &__smarttv {
        position: absolute;
        bottom: 0;
        left: calc(50% - 125px);
        width: 250px;
        height: 250px;
      }
      &__smarttv-content {
        position: absolute;
        bottom: 69px;
        left: calc(50% - 108px);
        width: 218px;
        height: 125px;
      }
      &__imac {
        position: absolute;
        bottom: 50px;
        right: 0;
        width: 120px;
        height: 105px;
      }
    }
    &__text-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 8rem;
      max-width: 540px;
      width: 100%;

      &__title {
        margin-bottom: 4rem;

        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #453D4C;
        span {
          color: #b06bea;
        }
      }
      &__subtitle {
        margin-bottom: 0;

        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #453D4C;
      }
      &__description {
        font-family: Nunito;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #453D4C;
      }
      &__button {
        margin-top: 4rem;
        width: 100%;
        max-width: 310px;
      }
    }
    &__version-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 2rem;
      margin-bottom: 2rem;
      padding-left: 0;
      padding-right: 0;

      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        list-style-type: none;
        padding: 0;
        height: 60px;

        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        line-height: 18px;
        color: #A217AB;
      }
    }
  }
}
@media screen and (min-width: 641px) {
  .checkout-payment-succeeded {
    background-position: -30rem 0, -30rem 0;

    &__container {
      width: 100%;
      max-width: 750px;
      margin-top: 10rem;

      &__logo {
        width: 336px;
        height: 206px;
        margin-bottom: 0;
      }
      &__options-container {
        width: 680px;
        height: 420px;

        &__iphonex {
          bottom: 84px;
          left: 60px;
          width: 116px;
          height: 59px;
        }
        &__smarttv {
          bottom: 0;
          left: calc(50% - 210px);
          width: 420px;
          height: 419px;
        }
        &__smarttv-content {
          bottom: 116px;
          left: calc(50% - 182px);
          width: 367px;
          height: 208px;
        }
        &__imac {
          bottom: 84px;
          right: 0;
          width: 236px;
          height: 206px;
        }
      }
      &__text-container {
        margin-top: 0;
        max-width: 540px;
        width: 100%;

        &__title {
          margin-bottom: 0;
          font-size: 25px;
        }
        &__subtitle {
          margin-top: 8px;
          font-size: 18px;
        }
        &__description {
          font-size: 18px;
          line-height: 24px;
          font-weight: 500;
        }
      }
      &__version-container {
        width: 100%;
        margin-top: 3rem;
        margin-bottom: 3rem;
        padding-left: 3rem;
        padding-right: 3rem;
        column-gap: 16px;

        &__item {
          flex-direction: row;
          align-items: center;
          font-size: 23.04px;
          line-height: 31px;
          svg {
            margin-right: 1rem;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .checkout-payment-succeeded {
    background-position: 0 0, 0 0;
  }
}
</style>
